import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSearch } from "./SearchContext";

const SEARCH_TIMEOUT = 1000;

export function useSearchNavigation() {
  const { query, setQuery } = useSearch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!query.trim()) return; // Don't navigate for empty query
    if (location.pathname.startsWith("/search")) {
      // Already on search page, just update query param
      const timeoutId = setTimeout(() => {
        navigate(`/search?query=${query}`, { replace: true });
      }, SEARCH_TIMEOUT);
      return () => clearTimeout(timeoutId);
    } else {
      // Navigate to search page
      const timeoutId = setTimeout(() => {
        navigate(`/search?query=${query}`);
      }, SEARCH_TIMEOUT);
      return () => clearTimeout(timeoutId);
    }
  }, [query, location.search, location.pathname, navigate]);

  useEffect(() => {
    if (!location.pathname.startsWith("/search")) {
      setQuery("");
    }
  }, [location.pathname, setQuery]);
}
